module.exports = __webpack_public_path__ + "img/cards-box-bg-old.d8508001.png";